// Shared rules for the rail's custom ranges (employees, founded, revenue).
// Kept out of FiltersRail.vue so the payload, chip strip and section badge can all read the same
// check, and so it can be tested directly.

// A bound counts only if it is a real number that is not negative. The inputs carry :min="0", but
// saved filters and KPI overlays write these fields directly and bypass that guard.
function toBound(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

// A range only filters once both bounds are in and the right way round. A half-typed, negative or
// inverted range must not reach the wire, the chip strip or the section badge.
export function isRangeApplied(min, max) {
  const lo = toBound(min);
  const hi = toBound(max);
  return lo != null && hi != null && lo <= hi;
}

// Why a typed range is not filtering yet, as a locale key; null when nothing is typed or the range
// is good. Mirrors isRangeApplied exactly so the message and the filtering can never disagree.
export function rangeErrorKey(min, max) {
  const has_min = min != null && min !== "";
  const has_max = max != null && max !== "";
  if (!has_min && !has_max) return null;
  if (!has_min || !has_max) return "expansion.filters.rangeIncomplete";
  if (toBound(min) == null || toBound(max) == null) return "expansion.filters.rangeNegative";
  if (Number(min) > Number(max)) return "expansion.filters.rangeInverted";
  return null;
}

// Only ever called behind isRangeApplied, so both bounds are present and a label can never
// collapse to a bare "–100"/"100–" (which read as a negative number).
export function formatRangeLabel(min, max) {
  return `${min}–${max}`;
}
